(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("myReports", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/reports/myReportsView.html",
            controller: ["$localStorage", "$state", MyReportsCtrl],
            controllerAs: "vm"
        };
        function MyReportsCtrl($localStorage, $state) {
            var vm = this;
            if (!$localStorage.myReports) {
                $localStorage.myReports = [
                    {
                        name: "Learning Path Completions - 2017",
                        report: "Learning Path Completion",
                        state: "main.reporting.learningPathCompletion",
                        filters: '{ "name":{ "enabled":false, "value":"" },"organization":{ "enabled":false, "value":"" },"groups":{ "enabled":false, "value":{ } },"pathName":{ "enabled":false, "value":"" },"assignedDate":{ "enabled":false, "fromValue":"", "toValue":"" },"activatedDate":{ "enabled":false, "fromValue":"", "toValue":"" },"completedDate":{ "enabled":true, "fromValue":"2017-01-01T07:00:00.000Z", "toValue":"2017-12-31T07:00:00.000Z" },"expiresDate":{ "enabled":false, "fromValue":"", "toValue":"" },"status":{ "enabled":true, "value":[3] } }'
                    },
                    {
                        name: "Learning Path Completions - 2016",
                        report: "Learning Path Completion",
                        state: "main.reporting.learningPathCompletion",
                        filters: '{ "name":{ "enabled":false, "value":"" },"organization":{ "enabled":false, "value":"" },"groups":{ "enabled":false, "value":{ } },"pathName":{ "enabled":false, "value":"" },"assignedDate":{ "enabled":false, "fromValue":"", "toValue":"" },"activatedDate":{ "enabled":false, "fromValue":"", "toValue":"" },"completedDate":{ "enabled":true, "fromValue":"2016-01-01T07:00:00.000Z", "toValue":"2016-12-31T07:00:00.000Z" },"expiresDate":{ "enabled":false, "fromValue":"", "toValue":"" },"status":{ "enabled":true, "value":[3] } }'
                    }
                ];
            }
            vm.reports = $localStorage.myReports;
            angular.forEach(vm.reports, function (report) {
                //var json = JSON.parse(report.filters);
                //report.params = JSON.parse('{ "filter" : ' + report.filters + "}");
                report.params = JSON.parse(report.filters);
            });
            vm.viewReport = function (report) {
                $state.go(report.state, { filter: report.params });
            };
            vm.scheduleReport = function (report) {
                $state.go("main.reporting.scheduledReports", { report: report });
            };
        }
    });
}());
